import React, {Component} from 'react';
import {BalanceItem} from "components/dashboard/buy-and-sell/BalanceItem";
import 'assets/sass/dashboard/buy-and-sell/Balances.scss';
import { AppContext } from 'app/state/AppContext';

export class Balances extends Component {
    static contextType = AppContext;

    currenciesToShow() {
        return this.props.currenciesToShow || []
    }

    renderBalanceItems() {
        const { currencyCodes } = this.context;
        let currencies = this.currenciesToShow().length === 0 ? currencyCodes : this.currenciesToShow();
        return currencies.map((currency) => (
            <BalanceItem balance={this.props.balance[currency]} currency={currency} key={currency}/>
        ))
    }

    render() {
        return (
            <div className="buy-and-sell-balances">
                <h5>Mis saldos</h5>
                {this.renderBalanceItems()}
            </div>
        );
    }
}
